export const brandOverlayIsDefault = {
  type: "boolean"
};
